import { MAX_NUMBER_OF_ELEMENTS } from 'js/config/defaults';

export const isOverImagesLimit = (count: number) => {
  return count > MAX_NUMBER_OF_ELEMENTS;
};
